// client/src/App.js

import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  useToast,
  CheckboxGroup,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import "../../App.css";
import CommonContext from '../../commonContext';
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';
import { MdDelete, MdEdit, MdAdd } from "react-icons/md";

function ExternalusersList() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const [isOpenCreate, setIsOpenCreate] = React.useState(false)
  const [isOpenEdit, setIsOpenEdit] = React.useState(false)
  const [idToDelete, setIdToDelete] = React.useState(null)
  const [idToUpdate, setIdToUpdate] = React.useState(null)
  const [nameToDelete, setNameToDelete] = React.useState("")
  const [categoryName, setCategoryName] = React.useState("")
  const [page, setPage] = React.useState(1)
  const [search, setSearch] = React.useState("")
  const [searchFather, setSearchFather] = React.useState("")
  const [advices, setAdvices] = React.useState(false)
  const [trainWithMe, setTrainWithMe] = React.useState(false)
  const [inHome, setInHome] = React.useState(false)
  const [idFather, setIdFather] = React.useState("0")
  const [fathers, setFathers] = React.useState([])
  const [defaultFather, setDefaultFather] = React.useState(0)
  const [sortOrder, setSortOrder] = React.useState("desc")
  const [sortedBy, setSortedBy] = React.useState("")
  const [name, setName] = React.useState("")
  const [surname, setSurname] = React.useState("")
  const [email, setEmail] = React.useState("")
  const [expiration, setExpiration] = React.useState("")
  const [expirationEng, setExpirationEng] = React.useState("")
  const [type, setType] = React.useState("")
  const [nextExpiration, setNextExpiration] = React.useState(false)

  const fetchExternalusers = async () => {


    postCall("/fetchExternalUsers", {}).then((data) => {

      setAllData(Array.from(data.data.map((item) => {
        return {
          id: item.id_external_user,
          name: item.name,
          email: item.email,
          surname: item.surname,
          type: item.type,
          expiration: Utils.convertDateToItaString(item.expiration, false),
          expirationEng: item.expiration,
        }
      })));

      /* put in tableContent only first n element from allData */
      setTableContent(Array.from(data.data.map((item) => {
        return {
          id: item.id_external_user,
          name: item.name,
          email: item.email,
          surname: item.surname,
          type: item.type,
          expiration: Utils.convertDateToItaString(item.expiration, false),
          expirationEng: item.expiration,
        }
      })).slice((page * 10) - 10, (page * 10)));

    });
  }

  useEffect(() => {

    fetchExternalusers()

    commonContext.setCurrentPath("Iscrizioni esterne")
    commonContext.setCurrentPage("externalusers")

  }, []);



  const nextExpirationFilter = async (e) => {
    console.log("okok")
    console.log(e.target.checked)
    setNextExpiration(e.target.checked)

    if (e.target.checked) {
      let mydata = allData.filter((item) => Utils.isNextExpiration(item.expirationEng))

      // Sort in descending order
      setSortedBy("expiration")
      let allDataSorted = []
      allDataSorted = [...mydata].sort((a, b) => a.expirationEng.localeCompare(b.expirationEng));
      setAllData(allDataSorted);
      setSortOrder('desc');

      setTableContent(Array.from(allDataSorted.map((item) => {

        return {
          id: item.id,
          name: item.name,
          email: item.email,
          surname: item.surname,
          type: item.type,
          expiration: item.expiration,
          expirationEng: item.expiration,
  
        }
      })).slice((page * 10) - 10, (page * 10)));
    } else {
      fetchExternalusers()
    }
  }

  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();
    if (expirationEng === "" || expirationEng === null || expirationEng === undefined) {
      toast({
        title: "Errore",
        description: "Inserisci una data di scadenza per l'abbonamento",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return
    }

    postCall("/updateExternalUser", {
      name: name,
      surname: surname,
      email: email,
      expiration: expirationEng,
      type: type,
      id_external_user: idToUpdate

    }).then((data) => {
      if (data.status === "success") {

        fetchExternalusers()
        setName("")
        setSurname("")
        setEmail("")
        setType("")
        setExpiration("")
        setExpirationEng("")
        setIdToUpdate(null)

        toast({
          title: "Perfetto",
          description: "Utente modificato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        onCloseEdit()

      } else {

        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseEdit = async () => {
    setIsOpenEdit(false)
  }

  const openEdit = async (id, name, surname, email, expirationEng, expiration, type) => {
    console.log("openEdit")

    setIdToUpdate(id)
    setName(name)
    setSurname(surname)
    setEmail(email)
    setExpirationEng(expirationEng.split("T")[0])
    setExpiration(expiration)
    setType(type)


    setIsOpenEdit(true)
  }
  /* END - EDIT FORM */


  /* BEGIN - CREATE FORM */

  const handleSubmit = async (event) => {
    event.preventDefault();

    postCall("/createExternalUser", {
      name: name,
      surname: surname,
      email: email,
      type: type,
      expiration: expirationEng
    }).then((data) => {
      if (data.status === "success") {

        fetchExternalusers()
        setName("")
        setSurname("")
        setEmail("")
        setType("")
        setExpiration("")
        setExpirationEng("")


        toast({
          title: "Perfetto",
          description: "Utente creato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })

        onCloseCreate()

      } else {

        toast({
          title: "Errore",
          description: data.error === "15" ? "Questa email esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseCreate = async () => {
    setIsOpenCreate(false)
  }

  const openCreate = async (id, name) => {
    console.log("openCreate")
    setName("")
    setSurname("")
    setEmail("")
    setExpiration("")
    setExpirationEng("")
    setType("")
    setIsOpenCreate(true)

  }
  /* END - CREATE FORM */


  /* BEGIN - DELETE FORM */
  const deleteExternalUser = async () => {
    console.log("onCloseDelete")


    setIsOpenDelete(false)
    postCall("/deleteExternalUser", {
      id_external_user: idToDelete
    }).then((data) => {
      if (data.status === "success") {

        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete))
        setIdToDelete(null)
        setNameToDelete("")

        toast({
          title: "Perfetto",
          description: "Utente eliminato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchExternalusers()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const onCloseDelete = async () => {
    setIsOpenDelete(false)
  }

  const openDelete = async (id, name) => {
    console.log("openDelete")
    setIdToDelete(id)
    setNameToDelete(name)
    setIsOpenDelete(true)
  }
  /* END - DELETE FORM */

  /* BEGIN - SORTABLE */

  const handleSortCreated = () => {
    setSortedBy("created")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.creation_date.localeCompare(b.creation_date))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.creation_date.localeCompare(a.creation_date));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        email: item.email,
        surname: item.surname,
        type: item.type,
        expiration: item.expiration,
        expirationEng: item.expiration,

      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  const handleSortName = () => {
    setSortedBy("name")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.name.localeCompare(b.name))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.name.localeCompare(a.name));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        email: item.email,
        surname: item.surname,
        type: item.type,
        expiration: item.expiration,
        expirationEng: item.expiration,

      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  const handleSortSurname = () => {
    setSortedBy("surname")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.surname.localeCompare(b.surname))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.surname.localeCompare(a.surname));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        email: item.email,
        surname: item.surname,
        type: item.type,
        expiration: item.expiration,
        expirationEng: item.expiration,

      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  const handleSortExpiration = () => {
    setSortedBy("expiration")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.expirationEng.localeCompare(b.expirationEng))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.expirationEng.localeCompare(a.expirationEng));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        email: item.email,
        surname: item.surname,
        type: item.type,
        expiration: item.expiration,
        expirationEng: item.expiration,

      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  /* END - SORTABLE */



  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>
      {/* BEGIN - FORM TO EDIT A NEW CATEGORY */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifica utente</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form>
              <FormControl id="categoryName">
                <FormLabel>Nome</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
                <FormLabel>Cognome</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={surname}
                  onChange={(event) => setSurname(event.target.value)}
                />
                <FormLabel>Email</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <FormLabel>Tipo</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={type}
                  onChange={(event) => setType(event.target.value)}
                />
                <FormLabel>Scadenza</FormLabel>
                <Input
                  mb="20px"
                  type="date"
                  value={expirationEng}
                  onChange={(event) => {
                    console.log("date: ", event.target.value)

                    setExpirationEng(event.target.value)
                    setExpiration(Utils.convertDateToItaString(event.target.value))
                  }}
                />

              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitEdit}>Modifica utente</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A NEW CATEGORY */}

      {/* BEGIN - FORM TO CREATE A NEW CATEGORY */}
      <Modal isOpen={isOpenCreate} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Crea nuovo utente esterno</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form>
              <FormControl id="categoryName">
                <FormLabel>Nome</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
                <FormLabel>Cognome</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={surname}
                  onChange={(event) => setSurname(event.target.value)}
                />
                <FormLabel>Email</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <FormLabel>Tipo</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={type}
                  onChange={(event) => setType(event.target.value)}
                />
                <FormLabel>Scadenza</FormLabel>
                <Input
                  mb="20px"
                  type="date"
                  value={expirationEng}
                  onChange={(event) => {
                    console.log("date: ", event.target.value)

                    setExpirationEng(event.target.value)
                    setExpiration(Utils.convertDateToItaString(event.target.value))
                  }}
                />

              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseCreate} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmit}>Crea utente</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW CATEGORY */}

      {/* BEGIN - BACK BUTTON */}
      {/* <Stack mt="5" ml="2" mb="5" mr="15" direction='row' spacing={4}>
        <Center><IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          icon={<IoMdArrowRoundBack />}
        /></Center>
        <Box w="5%"></Box>
        <Center >
          <Text
            fontSize="4xl"
            as="b"
            color="teal">
            {commonContext.currentPath}
          </Text>
        </Center>
      </Stack> */}
      {/* END - BACK BUTTON */}

      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        <Flex justifyContent="left" w="100%" >
          <Button mr="20px" leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={openCreate}>
            Nuovo utente esterno
          </Button>
          {/* <Link to="/sortCategories">
            <Button leftIcon={<BsSortUp />} colorScheme='orange' variant='solid' >
              Modifica ordine
            </Button>
          </Link> */}
        </Flex>
        <Flex justifyContent="right" w="100%" >
          {/*  <Input
            mr="20px"
            borderColor="black"
            w="20%"
            placeholder="Cerca categoria padre..."
            type="text"
            value={searchFather}
            onChange={(event) => {
              setSearchFather(event.target.value)
              setTableContent(allData.filter((item) => item.fatherName.toLowerCase().includes(event.target.value.toLowerCase()) && item.name.toLowerCase().includes(search.toLowerCase())))
            }}
          /> */}
          <Checkbox
            onChange={nextExpirationFilter}

          >Prossimi in scadenza</Checkbox>
          <Input
            ml="50px"
            borderColor="black"
            w="20%"
            placeholder="Cerca..."
            type="text"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value)
              setTableContent(allData.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase()) || item.surname.toLowerCase().includes(event.target.value.toLowerCase()) || (item.email ?? "").toLowerCase().includes(event.target.value.toLowerCase()) || item.expiration.toLowerCase().includes(event.target.value.toLowerCase()) || item.type.toLowerCase().includes(event.target.value.toLowerCase())))
            }}
          />
        </Flex>
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina utente
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente l'utente "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={deleteExternalUser} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}
      {allData.length < 1 && <Flex h="300px" alignItems="center" justifyContent="center">
        <Text fontSize="xl" as="b" color="teal">Nessuna categoria</Text>
      </Flex>}
      {/* BEGIN - TABLE */}
      {allData.length > 0 && <TableContainer h="100%" >
        <Table variant='striped' colorScheme='blue' w="100%" sx={{ tableLayout: "fixed" }}>
          {/* <TableCaption>Elenco delle categorie</TableCaption> */}
          <Thead>
            <Tr>
              <Th w="5%">ID</Th>
              <Th w="15%" _hover={{ cursor: "pointer" }} onClick={handleSortName}><Flex align="center" >Nome{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="15%" _hover={{ cursor: "pointer" }} onClick={handleSortSurname}><Flex align="center">Cognome{sortedBy === "father" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "surname" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="25%">Email</Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortExpiration}><Flex align="center">Scadenza{sortedBy === "expiration" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "expiration" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%">Tipo</Th>
              <Th w="12%"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tableContent.map((item) => (
              <Tr key={item.id}>
                <Td>{item.id}</Td>
                <Td title={item.name} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.name}</Td>
                <Td title={item.surname} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.surname}</Td>
                <Td title={item.email} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.email}</Td>
                <Td title={item.expiration} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.expiration}</Td>
                <Td>{item.type}</Td>
                <Td>
                  <IconButton
                    mr="2"
                    colorScheme='red'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdDelete />}
                    onClick={() => { openDelete(item.id, item.name + " " + item.surname) }}
                  />
                  <IconButton
                    mr="2"
                    colorScheme='orange'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdEdit />}
                    onClick={() => {
                      openEdit(item.id, item.name, item.surname, item.email, item.expirationEng, item.expiration, item.type)
                    }}
                  />
                </Td>
              </Tr>
            ))}

          </Tbody>
          <Tfoot>
            <Tr>
              <Th w="5%">ID</Th>
              <Th w="15%" _hover={{ cursor: "pointer" }} onClick={handleSortName}><Flex align="center" >Nome{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="15%" _hover={{ cursor: "pointer" }} onClick={handleSortSurname}><Flex align="center">Cognome{sortedBy === "father" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "surname" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="25%">Email</Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortExpiration}><Flex align="center">Scadenza{sortedBy === "expiration" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "father" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%">Tipo</Th>
              <Th w="12%"></Th>
            </Tr>

          </Tfoot>
        </Table>
      </TableContainer>}


      <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice((page * 10) - 20, (page * 10) - 10));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {page} / {Math.ceil(allData.length / 10)}
        </Text>
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page < Math.ceil(allData.length / 10)) {
              setTableContent(allData.slice((page * 10), (page * 10) + 10));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>

      {/* END - TABLE */}
    </div>

  );

}

export default ExternalusersList;